import { connect } from 'react-redux'
import WorkEntry from './work-entry'
import { getWork } from '../../../../../../stores/works/works.selectors'
import { getAssessmentFile } from '../../../../../../stores/assessment-file/assessment-file.selectors'
import dateFns from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const work = getWork(state, id)
  const assessmentFile = getAssessmentFile(state)
  return {
    date: dateFns.format(work.updated_at, 'MM/DD/YYYY HH:ss') || '',
    title: work.title || '-',
    description: work.description,
    thumb: work.media && work.media[0] && work.media[0].thumb_url,
    canUpdate:
      assessmentFile &&
      assessmentFile.policy &&
      assessmentFile.policy.can_update
  }
}

export default connect(
  mapStateToProps,
  null
)(WorkEntry)
